import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import './SeeRepliesLink.scss';
import { PageContext } from '../../../../contexts/ContextCreator';
import {
    emitEngagement,
    objectTypes,
} from '../../../../utilities/getStreamAnalytics';

// eslint-disable-next-line react/prop-types
const SeeRepliesLink = ({ content, url, commentHash }) => {
    const {
        pageProps: {
            session: { id, name },
        },
    } = useContext(PageContext);
    const onClickMetric = () => {
        emitEngagement(
            { id, name },
            {
                label: 'seeMoreReplies',
                score: 1,
                content: {
                    // eslint-disable-next-line react/prop-types
                    foreign_id: `${objectTypes()[content.type]}:${
                        content.hash
                    }`,
                    comment: {
                        lebel: `${objectTypes()[content.type]}:${content.hash}`,
                        id: `CommunityComment:${commentHash}`,
                    },
                },
            }
        );
    };
    return (
        <div className="component-Community-CommentBox-SeeRepliesLinkContainer">
            <a
                className="component-Community-CommentBox-SeeRepliesLink"
                href={url}
                onClick={onClickMetric}
            >
                See other replies
            </a>
        </div>
    );
};

SeeRepliesLink.propTypes = {
    url: PropTypes.string.isRequired,
    content: PropTypes.shape({
        hash: PropTypes.string,
        type: PropTypes.string,
    }),
};

SeeRepliesLink.defaultProps = {
    content: {
        hash: '',
        type: '',
    },
};

SeeRepliesLink.displayName = 'SeeRepliesLink';

export default SeeRepliesLink;
